import { render, staticRenderFns } from "./Global-Configuration.vue?vue&type=template&id=12154fea"
import script from "./Global-Configuration.vue?vue&type=script&lang=js"
export * from "./Global-Configuration.vue?vue&type=script&lang=js"
import style0 from "./Global-Configuration.vue?vue&type=style&index=0&id=12154fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports